import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { chevron } from '../svgs';
import { IS_PROD } from 'util/constants';
import styles from './test-embed-modal.module.css';

interface TestEmbedModalProps {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  botId: string;
}

const AVATAR_SCRIPT_URL = `https://assets2022.s3.us-east-1.amazonaws.com/Global/admin/ozone-ai-avatar.js`;
const endpoint = IS_PROD
  ? 'https://ozonemetaverse.io/graphql'
  : 'https://landing.o-zone.io/graphql';

export default function TestEmbedModal({
  isVisible,
  setIsVisible,
  botId,
}: TestEmbedModalProps) {
  const [isEmbedExpanded, setIsEmbedExpanded] = useState(false);

  const embedCode = `<script defer="defer" src="${AVATAR_SCRIPT_URL}"></script>
<ozone-ai-avatar avatarid="${botId}"></ozone-ai-avatar>`;

  useEffect(() => {
    if (isVisible) {
      const script = document.createElement('script');
      script.src = AVATAR_SCRIPT_URL;
      script.defer = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
    return undefined;
  }, [isVisible]);

  return (
    <Modal
      title='Your Avatar'
      open={isVisible}
      onCancel={() => setIsVisible(false)}
      footer={null}
      centered
      destroyOnClose
      zIndex={1010}
      width={800}
      className={styles.modal}
    >
      <div className={styles.modalContent}>
        <div className={styles.avatarContainer}>
          <div className={styles.chatContainer}>
            <div className={styles.avatarSection}>
              <ozone-ai-avatar
                avatarid={botId}
                graphqlendpoint={endpoint}
                className={styles.avatarElement}
              />
            </div>
          </div>

          <div className={styles.embedContainer}>
            <div
              className={styles.embedHeader}
              onClick={() => setIsEmbedExpanded(!isEmbedExpanded)}
            >
              <h3>Embed Code</h3>
              <div
                className={`${styles.chevronIcon} ${
                  isEmbedExpanded ? styles.expanded : ''
                }`}
              >
                {chevron}
              </div>
            </div>
            <div
              className={`${styles.embedContent} ${
                isEmbedExpanded ? styles.expanded : ''
              }`}
            >
              <div className={styles.embedCode}>{embedCode}</div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
